import React from 'react';

import shortId from 'shortid';
import { IoMdCheckmark } from 'react-icons/io';
import OptimizedImage from '../OptimizedImage';

const CareersAboutUs = ({ content, careers }) => {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col">
          <h2 className="subtitle bigger">{content.title}</h2>
          <div className="content">
            <p className={careers && 'why-us-fixed'}>{content.subtitle}</p>
          </div>
        </div>
      </div>
      <div className="row flex-column flex-md-row justify-content-between mt-4 points">
        {content.list.map(item => (
          <div
            key={shortId.generate()}
            className="col col-md-4 d-flex section-points"
          >
            <div className="ok-icon mr-3">
              <IoMdCheckmark />
            </div>
            <div className="ok-icon-text w-75">{item.subtitle}</div>
          </div>
        ))}
      </div>
      <OptimizedImage
        src="pages/about-us/culture_photo.png"
        className="mg-fluid main-img mt-5"
        alt="culture banner"
        title="culture banner"
      />
    </div>
  );
};

export default CareersAboutUs;
